import { useState } from "react";
import { Clock } from "lucide-react";
import { Button } from "@components/ui/button";
import { DayIntervalsFields } from "./day-intervals-fields.content";
import { DEFAULT_DAY_TEMPLATE } from "./training-schedule-form.constants";
import { getDayScheduleError } from "./training-schedule-form.utils";
import type { DayTemplate, HalfDay, HalfDayScheduleConfig } from "./training-schedule-form.types";

interface BulkDayTemplateProps {
  dayCount: number;
  onApply: (template: DayTemplate) => void;
}

export const BulkDayTemplate = ({ dayCount, onApply }: BulkDayTemplateProps) => {
  const [template, setTemplate] = useState<DayTemplate>(DEFAULT_DAY_TEMPLATE);

  const handleHalfDayChange = (halfDay: HalfDay, changes: Partial<HalfDayScheduleConfig>) => {
    setTemplate(current => ({ ...current, [halfDay]: { ...current[halfDay], ...changes } }));
  };

  // Same rules and wording as the per-day validation, reported once here instead of on every day
  const error = getDayScheduleError(template);

  return (
    <div role="group" aria-label="Journée type" className="rounded-lg border border-dashed border-primary/30 bg-primary/5 p-4">
      <div className="mb-3 flex items-center gap-2 text-sm font-medium text-primary">
        <Clock className="size-4" />
        <span>Journée type</span>
      </div>

      <div className="space-y-3">
        <DayIntervalsFields morning={template.morning} afternoon={template.afternoon} onHalfDayChange={handleHalfDayChange} />

        {error && <p className="text-sm font-medium text-destructive">{error}</p>}

        <div className="flex flex-wrap items-center justify-between gap-2">
          <span className="text-xs text-muted-foreground">Écrase les horaires déjà saisis.</span>
          <Button type="button" size="sm" onClick={() => onApply(template)} disabled={dayCount === 0 || error !== null}>
            Appliquer partout
          </Button>
        </div>
      </div>
    </div>
  );
};
